export default __webpack_public_path__ + "static/media/Book_1.b890def2.png";